import elementLocale from 'element-ui/lib/locale/lang/en';

export default {
  // Messages
  messages: {
    '{brand} ending in {last4}': '{brand} ending in {last4}',
    '{count} Pages Selected': 'No Pages Selected | 1 Page Selected | {count} Pages Selected',
    '{count} Pages': 'No Pages | 1 Page | {count} Pages',
    '{user} published changes to {page} on {site}': '{user} published changes to {page} on {site}',
    '{user} saved a draft of {page} on {site}': '{user} saved a draft of {page} on {site}',
    '100%': '100%',
    '25%': '25%',
    '50%': '50%',
    '75%': '75%',
    'Please review the {guidelines}. Non-commercial websites are verified to prevent abuse.': 'Please review the {guidelines}. Non-commercial websites are verified to prevent abuse.',
    'Website Classification Guidelines': 'Website Classification Guidelines',
    'A file already exists at the specified location.': 'A file already exists at the specified location.',
    'Access Control List (ACL)': 'Access Control List (ACL)',
    'Access Key': 'Access Key',
    'Actions': 'Actions',
    'Add To Favorites': 'Add To Favorites',
    'Additional Text': 'Additional Text',
    'Admin': 'Admin',
    'Advanced': 'Advanced',
    'Align Center': 'Align Center',
    'Align Left': 'Align Left',
    'Align Right': 'Align Right',
    'Alignment': 'Alignment',
    'All Images': 'All Images',
    'All Pages': 'All Pages',
    'Allow this user to change the settings for this account.': 'Allow this user to change the settings for this account.',
    'Allow this user to create, delete, and update sites.': 'Allow this user to create, delete, and update sites.',
    'Allow this user to create, delete, and update users.': 'Allow this user to create, delete, and update users.',
    'Allow this user to view invoices and manage payment info.': 'Allow this user to view invoices and manage payment info.',
    'Allow users to delete pages on this site.': 'Allow users to delete pages on this site.',
    'Allow users to duplicate pages on this site.': 'Allow users to duplicate pages on this site.',
    'Alternative text for users who can\'t see images.': 'Alternative text for users who can\'t see images.',
    'Amount': 'Amount',
    'An account has been created for you to manage your website. Please follow the link below to confirm your account.': 'An account has been created for you to manage your website. Please follow the link below to confirm your account.',
    'An error occurred. Please try your request again later.': 'An error occurred. Please try your request again later.',
    'An invitation will be sent to this email address when the user is created.': 'An invitation will be sent to this email address when the user is created.',
    'Analytics': 'Analytics',
    'Anchor': 'Anchor',
    'API Access': 'API Access',
    'App Name': 'App Name',
    'Apply': 'Apply',
    'Are you sure you want to delete {count} files?': 'There is nothing to delete! | Are you sure you want to delete this file? | Are you sure you want to delete these {count} files?',
    'Are you sure you want to do this?': 'Are you sure you want to do this?',
    'Authentication': 'Authentication',
    'Average Time On Site': 'Average Time On Site',
    'Back To Site': 'Back To Site',
    'Back': 'Back',
    'Background': 'Background',
    'Best Fit': 'Best Fit',
    'Billing': 'Billing',
    'Bio': 'Bio',
    'Blockquote': 'Blockquote',
    'Blocks cannot contain ID attributes.': 'Blocks cannot contain ID attributes.',
    'Blocks': 'Blocks',
    'Bold': 'Bold',
    'Bounce Rate': 'Bounce Rate',
    'Branding': 'Branding',
    'Browse': 'Browse',
    'Browsers': 'Browsers',
    'Bucket': 'Bucket',
    'Bug Report': 'Bug Report',
    'Bulleted List': 'Bulleted List',
    'Can this question help other users?': 'Can this question help other users?',
    'Cancel': 'Cancel',
    'Caption': 'Caption',
    'Cell': 'Cell',
    'Change Password': 'Change Password',
    'Change Profile Picture': 'Change Profile Picture',
    'Changing this will cause all active users to be logged out immediately. You are responsible for informing users of the new domain.': 'Changing this will cause all active users to be logged out immediately. You are responsible for informing users of the new domain.',
    'Choose Image': 'Choose Image',
    'Cities': 'Cities',
    'Classification': 'Classification',
    'Cleanup Code': 'Cleanup Code',
    'Client': 'Client',
    'Code Block': 'Code Block',
    'Code': 'Code',
    'Color': 'Color',
    'Column': 'Column',
    'Commercial': 'Commercial',
    'Confirm My Account': 'Confirm My Account',
    'Congratulations! Two-factor authentication has been enabled for your account.': 'Congratulations! Two-factor authentication has been enabled for your account.',
    'Connect your Google Analytics account to enable the analytics dashboard for selected sites.': 'Connect your Google Analytics account to enable the analytics dashboard for selected sites.',
    'Connecting...': 'Connecting…',
    'Connection successful!': 'Connection successful!',
    'Content': 'Content',
    'Continents': 'Continents',
    'Continue Editing': 'Continue Editing',
    'Continue': 'Continue',
    'Copy and paste the video\'s URL or embed code here.': 'Copy and paste the video\'s URL or embed code here.',
    'Countries': 'Countries',
    'Cover': 'Cover',
    'Create Block': 'Create Block',
    'Create Folder': 'Create Folder',
    'Create Page': 'Create Page',
    'Create Site': 'Create Site',
    'Create Template': 'Create Template',
    'Create User': 'Create User',
    'Current Password': 'Current Password',
    'Customize Invoices': 'Customize Invoices',
    'Dark Logo': 'Dark Logo',
    'Dashboard': 'Dashboard',
    'Date': 'Date',
    'Decrease Indent': 'Decrease Indent',
    'Delete Anchor': 'Delete Anchor',
    'Delete Block': 'Delete Block',
    'Delete Code Block': 'Delete Code Block',
    'Delete Column': 'Delete Column',
    'Delete Gallery': 'Delete Gallery',
    'Delete Image': 'Delete Image',
    'Delete My Account': 'Delete My Account',
    'Delete Row': 'Delete Row',
    'Delete This Site': 'Delete This Site',
    'Delete This User': 'Delete This User',
    'Delete Video': 'Delete Video',
    'Delete': 'Delete',
    'Delete Pages': 'Delete Pages',
    'Demo Site': 'Demo Site',
    'Depth of Visit': 'Depth of Visit',
    'Description': 'Description',
    'Devices': 'Devices',
    'Did we make a mistake? Let us know!': 'Did we make a mistake? Let us know!',
    'Disable API Access': 'Disable API Access',
    'Disable Line Wrapping': 'Disable Line Wrapping',
    'Disable lockdown to make changes to this site.': 'Disable lockdown to make changes to this site.',
    'Disable Two-factor Authentication': 'Disable Two-factor Authentication',
    'Disable': 'Disable',
    'Documentation': 'Documentation',
    'Domain': 'Domain',
    'Done': 'Done',
    'Draft': 'Draft',
    'Drafts & Revisions': 'Drafts & Revisions',
    'Drag and drop an HTML file or copy and paste the full source of your block.': 'Drag and drop an HTML file or copy and paste the full source of your block.',
    'Drag and drop an HTML file or copy and paste the full source of your page template.': 'Drag and drop an HTML file or copy and paste the full source of your page template.',
    'Duplicate ID': 'Duplicate ID',
    'Duplicate': 'Duplicate',
    'Duplicate Pages': 'Duplicate Pages',
    'Edit Block': 'Edit Block',
    'Edit Metadata': 'Edit Metadata',
    'Edit Profile': 'Edit Profile',
    'Edit Site': 'Edit Site',
    'Edit Source': 'Edit Source',
    'Edit Template': 'Edit Template',
    'Edit User': 'Edit User',
    'Edit': 'Edit',
    'Educational': 'Educational',
    'Email': 'Email',
    'Embed Code': 'Embed Code',
    'Enable access to programmatically manage sites, users, and more.': 'Enable access to programmatically manage sites, users, and more.',
    'Enable access to the CMS from a white-label domain.': 'Enable access to the CMS from a white-label domain.',
    'Enable API Access': 'Enable API Access',
    'Enable Change Notifications': 'Enable Change Notifications',
    'Enable Line Wrapping': 'Enable Line Wrapping',
    'Enable Lockdown': 'Enable Lockdown',
    'Enable Pages': 'Enable Pages',
    'Enable Two-factor Authentication': 'Enable Two-factor Authentication',
    'Enable': 'Enable',
    'End Date': 'End Date',
    'Enter a brief description of this block.': 'Enter a brief description of this block.',
    'Enter a brief description of this template.': 'Enter a brief description of this template.',
    'Enter a caption for the selected photo.': 'Enter a caption for the selected photo.',
    'Enter a name for the new folder.': 'Enter a name for the new folder.',
    'Enter a name for your website.': 'Enter a name for your website.',
    'Enter the code generated by your app': 'Enter the code generated by your app',
    'Enter your website\'s URL.': 'Enter your website\'s URL.',
    'Error': 'Error',
    'Exit Pages': 'Exit Pages',
    'Failed to locate content region.': 'Failed to locate content region.',
    'Favicon': 'Favicon',
    'Favorites': 'Favorites',
    'Feature Request': 'Feature Request',
    'File Extension': 'File Extension',
    'Filename': 'Filename',
    'Files cannot be recovered once they are deleted.': 'Files cannot be recovered once they are deleted.',
    'Files cannot be uploaded here.': 'Files cannot be uploaded here.',
    'Files': 'Files',
    'Finished With Errors': 'Finished With Errors',
    'Finished': 'Finished',
    'Folder': 'Folder',
    'Forgot your password?': 'Forgot your password?',
    'Format': 'Format',
    'Gallery': 'Gallery',
    'General Support': 'General Support',
    'General': 'General',
    'Get a helpful response in less than 24 hours, even on weekends and holidays.': 'Get a helpful response in less than 24 hours, even on weekends and holidays.',
    'Give this user administrative privileges.': 'Give this user administrative privileges.',
    'Give your clients a custom solution with your company\'s branding. Clients will see your business, your logo, and your custom domain.': 'Give your clients a custom solution with your company\'s branding. Clients will see your business, your logo, and your custom domain.',
    'Go to the settings page to enable this feature.': 'Go to the settings page to enable this feature.',
    'Heading {num}': 'Heading {num}',
    'Highlight': 'Highlight',
    'Home Folder': 'Home Folder',
    'Homepage': 'Homepage',
    'Host': 'Host',
    'I have stored my recovery code in a secure place': 'I have stored my recovery code in a secure place',
    'If set, clients will be sent to this URL instead of the standard support page.': 'If set, clients will be sent to this URL instead of the standard support page.',
    'If so, consider posting it to the {forum} instead.': 'If so, consider posting it to the {forum} instead.',
    'If you didn\'t request this, you can safely ignore this message.': 'If you didn\'t request this, you can safely ignore this message.',
    'If your bucket has ACLs enabled, enable this option to give "public-read" permissions to uploaded files.': 'If your bucket has ACLs enabled, enable this option to give "public-read" permissions to uploaded files.',
    'If your website doesn\'t use HTTPS, stylesheets and other mixed content will not load in the editor. Please consider securing your website with an SSL certificate.': 'If your website doesn\'t use HTTPS, stylesheets and other mixed content will not load in the editor. Please consider securing your website with an SSL certificate.',
    'Image': 'Image',
    'Increase Indent': 'Increase Indent',
    'Insert Anchor': 'Insert Anchor',
    'Insert Block': 'Insert Block',
    'Insert Code Block': 'Insert Code Block',
    'Insert Column After': 'Insert Column After',
    'Insert Column Before': 'Insert Column Before',
    'Insert Gallery': 'Insert Gallery',
    'Insert Image': 'Insert Image',
    'Insert Link': 'Insert Link',
    'Insert Row After': 'Insert Row After',
    'Insert Row Before': 'Insert Row Before',
    'Insert Table': 'Insert Table',
    'Insert Video': 'Insert Video',
    'Insert': 'Insert',
    'Invoice': 'Invoice',
    'Italic': 'Italic',
    'Keyboard Shortcuts': 'Keyboard Shortcuts',
    'Keywords': 'Keywords',
    'Landing Pages': 'Landing Pages',
    'Landscape': 'Landscape',
    'Language': 'Language',
    'Language[computer]': 'Language',
    'Languages': 'Languages',
    'Last {days} days': 'Last {days} days',
    'Last seen {date}': 'Last seen {date}',
    'Last year': 'Last year',
    'Launch {appName}': 'Launch {appName}',
    'Length of Visit': 'Length of Visit',
    'Light Logo': 'Light Logo',
    'Link': 'Link',
    'Links to this page will stop working. You should only change the filename if you\'re sure nothing is linking to this page.': 'Links to this page will stop working. You should only change the filename if you\'re sure nothing is linking to this page.',
    'Lists': 'Lists',
    'Load More': 'Load More',
    'Loading...': 'Loading…',
    'Login': 'Login',
    'Logo': 'Logo',
    'Logos': 'Logos',
    'Logout': 'Logout',
    'Lost your device?': 'Lost your device?',
    'Main': 'Main',
    'Make Administrator': 'Make Administrator',
    'Manage Billing': 'Manage Billing',
    'Manage Blocks': 'Manage Blocks',
    'Manage Files': 'Manage Files',
    'Manage Pages': 'Manage Pages',
    'Manage Settings': 'Manage Settings',
    'Manage Sites': 'Manage Sites',
    'Manage Templates': 'Manage Templates',
    'Manage Users': 'Manage Users',
    'Merge Cells': 'Merge Cells',
    'Metadata': 'Metadata',
    'Missing ID': 'Missing ID',
    'Mobile Devices': 'Mobile Devices',
    'Move Down': 'Move Down',
    'Move Up': 'Move Up',
    'My Account': 'My Account',
    'Name': 'Name',
    'Need something else to appear on your invoice?': 'Need something else to appear on your invoice?',
    'Never logged in': 'Never logged in',
    'New Block': 'New Block',
    'New Folder': 'New Folder',
    'New Page': 'New Page',
    'New Password': 'New Password',
    'New Site': 'New Site',
    'New Template': 'New Template',
    'New User': 'New User',
    'New Visits': 'New Visits',
    'No Blocks': 'No Blocks',
    'No Files': 'No Files',
    'No Images': 'No Images',
    'No Pages': 'No Pages',
    'No Recent Activity': 'No Recent Activity',
    'No Results': 'No Results',
    'No Revisions': 'No Revisions',
    'No Sites': 'No Sites',
    'No Templates': 'No Templates',
    'Non-profit': 'Non-profit',
    'None': 'None',
    'Not Found': 'Not Found',
    'Now that you\'re connected, let\'s enable some pages!': 'Now that you\'re connected, let\'s enable some pages!',
    'Now that you\'ve confirmed your account, you can manage your website any time using the link below.': 'Now that you\'ve confirmed your account, you can manage your website any time using the link below.',
    'Numbered List': 'Numbered List',
    'Once your account is deleted, it cannot be recovered!': 'Once your account is deleted, it cannot be recovered!',
    'Open in a New Window': 'Open in a New Window',
    'Open Revision': 'Open Revision',
    'Operating Systems': 'Operating Systems',
    'Organization': 'Organization',
    'Orientation': 'Orientation',
    'Out of Service': 'Out of Service',
    'Overview': 'Overview',
    'Owner': 'Owner',
    'Pages Per Visit': 'Pages Per Visit',
    'Pages': 'Pages',
    'Pageviews': 'Pageviews',
    'Paragraph': 'Paragraph',
    'Password': 'Password',
    'Passwords must be at least eight characters long.': 'Passwords must be at least eight characters long.',
    'Payment History': 'Payment History',
    'Payment Source': 'Payment Source',
    'Permissions': 'Permissions',
    'Personal Access Token': 'Personal Access Token',
    'Personal': 'Personal',
    'Photo of {name}': 'Photo of {name}',
    'Pin to Top': 'Pin to Top',
    'Please check your email for further instructions.': 'Please check your email for further instructions.',
    'Please choose a password for your new account.': 'Please choose a password for your new account.',
    'Please contact your administrator for details.': 'Please contact your administrator for details.',
    'Please correct the highlighted errors.': 'Please correct the highlighted errors.',
    'Please enter the recovery code you were given when you enabled two-factor authentication.': 'Please enter the recovery code you were given when you enabled two-factor authentication.',
    'Please enter your password to continue.': 'Please enter your password to continue.',
    'Please open your authentication app and enter the two-factor authentication code here.': 'Please open your authentication app and enter the two-factor authentication code here.',
    'Please provide details about the issue.': 'Please provide details about the issue.',
    'Please scan this code with your authentication app. If you don\'t have one, try one of these.': 'Please scan this code with your authentication app. If you don\'t have one, try one of these.',
    'Please store this recovery code in a secure place such as a password manager. If you lose your device, you will need it to access your account.': 'Please store this recovery code in a secure place such as a password manager. If you lose your device, you will need it to access your account.',
    'Please upgrade your account to unlock this feature.': 'Please upgrade your account to unlock this feature.',
    'Port': 'Port',
    'Portrait': 'Portrait',
    'Position Your Photo': 'Position Your Photo',
    'Preformatted Text': 'Preformatted Text',
    'Prevent Search Engines From Indexing This Page': 'Prevent Search Engines From Indexing This Page',
    'Prioritize My Request': 'Prioritize My Request',
    'Protocol': 'Protocol',
    'Provide a short and descriptive name for the anchor.': 'Provide a short and descriptive name for the anchor.',
    'Provide as much detail as necessary. For example, how can the problem be replicated? Are you receiving an error message?': 'Provide as much detail as necessary. For example, how can the problem be replicated? Are you receiving an error message?',
    'Publish': 'Publish',
    'Published by {name}': 'Published by {name}',
    'Published Changes': 'Published Changes',
    'Publishing {processed} of {total} Pages': 'Publishing 0 Pages | Publishing 1 Page | Publishing {processed} of {total} Pages',
    'Receive an email when others publish changes to this site.': 'Receive an email when others publish changes to this site.',
    'Recent Activity': 'Recent Activity',
    'Recover My Account': 'Recover My Account',
    'Recover My Password': 'Recover My Password',
    'Recovery Code': 'Recovery Code',
    'Redo': 'Redo',
    'Referring URLs': 'Referring URLs',
    'Refresh': 'Refresh',
    'Regenerate': 'Regenerate',
    'Region': 'Region',
    'Remember This Device': 'Remember This Device',
    'Remove Formatting': 'Remove Formatting',
    'Remove Link': 'Remove Link',
    'Remove': 'Remove',
    'Rename': 'Rename',
    'Repeat': 'Repeat',
    'Require for all users': 'Require for all users',
    'Require Two-factor Authentication': 'Require Two-factor Authentication',
    'Reset Demo': 'Reset Demo',
    'Reset My Password': 'Reset My Password',
    'Reset Your Password': 'Reset Your Password',
    'Resources': 'Resources',
    'Revoke': 'Revoke',
    'Rotate': 'Rotate',
    'Row': 'Row',
    'Save Changes': 'Save Changes',
    'Save Draft & Upgrade': 'Save Draft & Upgrade',
    'Save Draft': 'Save Draft',
    'Saved a Draft': 'Saved a Draft',
    'Saved by {name}': 'Saved by {name}',
    'Saving...': 'Saving…',
    'Screen Colors': 'Screen Colors',
    'Screen Resolutions': 'Screen Resolutions',
    'Search hundreds of thousands of free, high-quality photos.': 'Search hundreds of thousands of free, high-quality photos.',
    'Search Pages': 'Search Pages',
    'Search Sites': 'Search Sites',
    'Search Unsplash': 'Search Unsplash',
    'Search Users': 'Search Users',
    'Secret Access Key': 'Secret Access Key',
    'Section Break': 'Section Break',
    'Select a logo to use on dark backgrounds.': 'Select a logo to use on dark backgrounds.',
    'Select a logo to use on light backgrounds.': 'Select a logo to use on light backgrounds.',
    'Select a profile to enable the analytics dashboard for this site.': 'Select a profile to enable the analytics dashboard for this site.',
    'Select an image to use as the favicon.': 'Select an image to use as the favicon.',
    'Select the folder that contains your homepage.': 'Select the folder that contains your homepage.',
    'Select the folder where uploaded files will be stored.': 'Select the folder where uploaded files will be stored.',
    'Select': 'Select',
    'Selected Pages': 'Selected Pages',
    'Server Error': 'Server Error',
    'Services': 'Services',
    'Settings': 'Settings',
    'Shown in browser tabs and search results.': 'Shown in browser tabs and search results.',
    'Shown under the title in search results.': 'Shown under the title in search results.',
    'Shown when the page is shared in third-party apps.': 'Shown when the page is shared in third-party apps.',
    'Shown when users hover over the link.': 'Shown when users hover over the link.',
    'Sites': 'Sites',
    'Size': 'Size',
    'Small Print': 'Small Print',
    'Sorry, but the editor could not be initialized. Please reload the page and try again.': 'Sorry, but the editor could not be initialized. Please reload the page and try again.',
    'Source': 'Source',
    'Split Cells': 'Split Cells',
    'Squarish': 'Squarish',
    'Start Date': 'Start Date',
    'Start typing to add a site...': 'Start typing to add a site…',
    'Strikethrough': 'Strikethrough',
    'Submit Request': 'Submit Request',
    'Submit': 'Submit',
    'Subscript': 'Subscript',
    'Superscript': 'Superscript',
    'Support URL': 'Support URL',
    'Support': 'Support',
    'Table': 'Table',
    'Technical': 'Technical',
    'Template': 'Template',
    'Test Connection': 'Test Connection',
    'Thanks for confirming your {appName} account!': 'Thanks for confirming your {appName} account!',
    'Thanks for using {appName}!': 'Thanks for using {appName}!',
    'The analytics dashboard has not been enabled for this site.': 'The analytics dashboard has not been enabled for this site.',
    'The demo has been reset.': 'The demo has been reset.',
    'The link you followed has expired.': 'The link you followed has expired.',
    'The page will be created inside this folder on your server.': 'The page will be created inside this folder on your server.',
    'The page you requested could not be found.': 'The page you requested could not be found.',
    'The selected path is outside of the site\'s home folder.': 'The selected path is outside of the site\'s home folder.',
    'The token you entered is not valid.': 'The token you entered is not valid.',
    'This adds an extra layer of security to your account by requiring access to a known device (such as a smartphone) before logging into your account.': 'This adds an extra layer of security to your account by requiring access to a known device (such as a smartphone) before logging into your account.',
    'This appears to be a commercial website, but you\'re on a personal plan. Please upgrade your account to publish this website.': 'This appears to be a commercial website, but you\'re on a personal plan. Please upgrade your account to publish this website.',
    'This cannot be changed when you\'re logged in to your custom domain.': 'This cannot be changed when you\'re logged in to your custom domain.',
    'This domain is already in use.': 'This domain is already in use.',
    'This domain is no longer active.': 'This domain is no longer active.',
    'This email address is already in use.': 'This email address is already in use.',
    'This email address is not registered.': 'This email address is not registered.',
    'This information will appear on all of your invoices.': 'This information will appear on all of your invoices.',
    'This is used to reference the page in the CMS.': 'This is used to reference the page in the CMS.',
    'This is where you and your clients will go to access the CMS.': 'This is where you and your clients will go to access the CMS.',
    'This is your API token. Protect it like you would a password. If your token is ever compromised, you can regenerate it using the button above.': 'This is your API token. Protect it like you would a password. If your token is ever compromised, you can regenerate it using the button above.',
    'This page doesn\'t have any content regions.': 'This page doesn\'t have any content regions.',
    'This request cannot be completed because the site is on lockdown.': 'This request cannot be completed because the site is on lockdown.',
    'This site has reached the maximum number of templates allowed.': 'This site has reached the maximum number of templates allowed.',
    'This Site is on Lockdown': 'This Site is on Lockdown',
    'This type of file is not supported.': 'This type of file is not supported.',
    'This user is an administrator so they have access to all sites. You need to disable administrative privileges if you want to limit their access.': 'This user is an administrator so they have access to all sites. You need to disable administrative privileges if you want to limit their access.',
    'This user will have access to the following sites.': 'This user will have access to the following sites.',
    'This will be displayed instead of "Surreal CMS" throughout the app.': 'This will be displayed instead of “Surreal CMS” throughout the app.',
    'This will be shown in search engine results, browser tabs, bookmarks, etc.': 'This will be shown in search engine results, browser tabs, bookmarks, etc.',
    'This will cause existing links to this file to stop working.': 'This will cause existing links to this file to stop working.',
    'This will delete the site from the CMS, but not from your web server.': 'This will delete the site from the CMS, but not from your web server.',
    'This will delete the user and revoke all access to the CMS.': 'This will delete the user and revoke all access to the CMS.',
    'This will delete your account permanently.': 'This will delete your account permanently.',
    'This will destroy your token and disable API access. All applications that use this token will stop working.': 'This will destroy your token and disable API access. All applications that use this token will stop working.',
    'This will permanently delete the selected blocks.': 'This will permanently delete the selected blocks.',
    'This will permanently delete the selected pages from your web server.': 'This will permanently delete the selected pages from your web server.',
    'This will permanently delete the selected templates.': 'This will permanently delete the selected templates.',
    'This will remove the selected pages from the CMS, but not from your web server.': 'This will remove the selected pages from the CMS, but not from your web server.',
    'This will require all users to enable two-factor authentication. Every user will need to use an app such as Google Authenticator before they can access their account.': 'This will require all users to enable two-factor authentication. Every user will need to use an app such as Google Authenticator before they can access their account.',
    'Tile': 'Tile',
    'Title': 'Title',
    'To change your subscription, please visit the {billing} section.': 'To change your subscription, please visit the {billing} section.',
    'To enable two-factor authentication for just your account, visit the profile page.': 'To enable two-factor authentication for just your account, visit the profile page.',
    'to': 'to',
    'Today': 'Today',
    'Toggle Full Screen Mode': 'Toggle Full Screen Mode',
    'Toggle Header Cells': 'Toggle Header Cells',
    'Traffic Sources': 'Traffic Sources',
    'Traffic': 'Traffic',
    'Two-factor Authentication': 'Two-factor Authentication',
    'Type a few sentences about this user.': 'Type a few sentences about this user.',
    'Type a few sentences about yourself.': 'Type a few sentences about yourself.',
    'Type of Website': 'Type of Website',
    'Unable to authenticate with your server.': 'Unable to authenticate with your server.',
    'Unable to connect to your website.': 'Unable to connect to your website.',
    'Unable to create the directory on your server.': 'Unable to create the directory on your server.',
    'Unable to delete the file from your server.': 'Unable to delete the file from your server.',
    'Unable to download the file from your server.': 'Unable to download the file from your server.',
    'Unable to list the directory on your server.': 'Unable to list the directory on your server.',
    'Unable to move the file on your server.': 'Unable to move the file on your server.',
    'Unable to upload the file to your server.': 'Unable to upload the file to your server.',
    'Undo': 'Undo',
    'Unsaved Changes': 'Unsaved Changes',
    'Unsupported Element': 'Unsupported Element',
    'Update Anchor': 'Update Anchor',
    'Update Background': 'Update Background',
    'Update Code Block': 'Update Code Block',
    'Update Gallery': 'Update Gallery',
    'Update Image': 'Update Image',
    'Update Link': 'Update Link',
    'Update Metadata': 'Update Metadata',
    'Update Payment Info': 'Update Payment Info',
    'Update Video': 'Update Video',
    'Upgrade My Account': 'Upgrade My Account',
    'Upgrade Required': 'Upgrade Required',
    'Upgrade to unlock priority support, commercial sites, and more features!': 'Upgrade to unlock priority support, commercial sites, and more features!',
    'Upgrade': 'Upgrade',
    'Upload Folder': 'Upload Folder',
    'Upload': 'Upload',
    'Uploads': 'Uploads',
    'URL': 'URL',
    'Username': 'Username',
    'Users': 'Users',
    'Video': 'Video',
    'View Info': 'View Info',
    'View Invoice': 'View Invoice',
    'View on Unsplash': 'View on Unsplash',
    'View Webpage': 'View Webpage',
    'View Website': 'View Website',
    'Visit Documentation': 'Visit Documentation',
    'Visitors': 'Visitors',
    'Visits': 'Visits',
    'Warning': 'Warning',
    'We can save your changes as a draft so you can publish them after you\'ve upgraded.': 'We can save your changes as a draft so you can publish them after you\'ve upgraded.',
    'We hope you enjoy using {appName}': 'We hope you enjoy using {appName}',
    'We provide a demo site for you to experiment with. If you\'ve modified it or removed it, you can reset it here.': 'We provide a demo site for you to experiment with. If you\'ve modified it or removed it, you can reset it here.',
    'We were unable to fetch data from your analytics provider.': 'We were unable to fetch data from your analytics provider.',
    'Welcome to {appName}': 'Welcome to {appName}',
    'Welcome!': 'Welcome!',
    'What do you need help with?': 'What do you need help with?',
    'When enabled, users won\'t be able to publish changes to the site.': 'When enabled, users won\'t be able to publish changes to the site.',
    'Which site does this involve?': 'Which site does this involve?',
    'White-label settings will be applied when you login in to your custom domain.': 'White-label settings will be applied when you login in to your custom domain.',
    'White-label Settings': 'White-label Settings',
    'Yesterday': 'Yesterday',
    'You must enable two-factor authentication for your own account before requiring it for everyone.': 'You must enable two-factor authentication for your own account before requiring it for everyone.',
    'You recently requested to reset the password for your {appName} account.': 'You recently requested to reset the password for your {appName} account.',
    'Your administrator requires two-factor authentication for all accounts.': 'Your administrator requires two-factor authentication for all accounts.',
    'Your analytics provider says you do not have permission to access this property.': 'Your analytics provider says you do not have permission to access this property.',
    'Your changes have been saved.': 'Your changes have been saved.',
    'Your changes haven\'t been saved. Are you sure you want to continue?': 'Your changes haven\'t been saved. Are you sure you want to continue?',
    'Your favorites will appear in the sidebar for quick access.': 'Your favorites will appear in the sidebar for quick access.',
    'Your password has been updated.': 'Your password has been updated.',
    'Your password is incorrect.': 'Your password is incorrect.',
    'Your request has been received. We\'ll be in touch soon!': 'Your request has been received. We\'ll be in touch soon!',
    'Your syntax highlighter will use this to identify the programming language.': 'Your syntax highlighter will use this to identify the programming language.',
    'Zoom': 'Zoom',

    // Import the corresponding Element UI locale
    ...elementLocale
  },

  // Date formats
  dateTimeFormats: {
    'short': {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    'medium': {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    },
    'long': {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    }
  },

  // Number formats
  numberFormats: {
    'currency': {
      style: 'currency',
      currency: 'USD'
    },
    'currencyInteger': {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    'decimal': {
      style: 'decimal',
      useGrouping: true
    },
    'integer': {
      style: 'decimal',
      useGrouping: true,
      maximumFractionDigits: 0
    }
  }
};
